export enum ShopFacilities {
  RECEPTION = 'reception',
  WIFI = 'wifi',
  COURTESYVEHICLE = 'courtesy_car',
  DELIVERY = 'delivery',
  PARKING = 'parking',
  SECURITY = 'security',
  RESTROOM = 'restroom',
  REFRESHMENT = 'refreshment',
  DISABLEDACCESS = 'disabled_access'
}

export enum ShopServices {
  MOT = 'mot',
  WINTERCHECK = 'winter_check',
  SUMMERCHECK = 'summer_check',
  TYREFITTING = 'tyre_fitting',
  AC = 'air_conditioning',
  ENGINEDIAGNOSTICS = 'engine_diagnostics',
  HYBRID = 'hybrid',
  EXHAUST = 'exhaust',
  GENERAL = 'general',
  PICKUP = 'pickup_dropoff',
  BRAKEFITTING = 'brake_fitting_check',
  CLUTCH = 'clutch_replacement',
  ENGINEREPAIRS = 'engine_transmission_repairs',
  DPF = 'dpf_cleaning',
  ELECTRICALREPAIRS = 'electrical_repairs',
  ADAS = 'adas_calibration_repairs',
  BODYREPAIRS = 'body_repairs',
  VEHICLEHEALTH = 'vehicle_health_check',
  BREAKDOWNASSISTANCE = 'breakdown_recovery',
  VMSPECIALIST = 'vm_specialist',
  SERVICEPLANS = 'service_plans'
}

export enum ShopPaymentMethods {
  CASH = 'cash',
  DEBITCARD = 'debit_card',
  CREDITCARD = 'credit_card'
}
